'use strict'

import $ from 'jquery'

export default class Click {
  constructor () {
    $('header #navbar .nav > li > a').click(function () {
      if ($(window).width() > 767) {
        window.location = $(this).attr('href')
      }
    })
  }
}
